// 桌面提醒
export const notify = function (
  title = '',
  content = '',
  icon = '',
  callback = () => {}
) {
  if (!title && !content) {
    title = '桌面提醒'
    content = '设置成功'
  }

  const isNewNotificationSupported = function () {
    if (!window.Notification || !Notification.requestPermission) {
      return false
    }
    if (window.Notification.permission !== 'granted') {
      // new Notification is supported, so prompt the user for permission.
      window.Notification.requestPermission()
      return false
    }
    // Chrome for Android TypeError
    if (/Android/i.test(navigator.userAgent)) {
      try {
        new Notification('')
      } catch (e) {
        if (e.name === 'TypeError') {
          return false
        }
      }
    }
    return true
  }

  if (!isNewNotificationSupported()) {
    return
  }

  const notification = new window.Notification(title, {
    icon,
    body: content,
  })

  notification.onclick = function () {
    callback && callback()
    notification.close()
  }

  notification.onshow = function () {
    setTimeout(() => {
      notification.close()
    }, 10000)
  }
}

export function requestPermission() {
  if (!window.Notification || !Notification.requestPermission) {
    return
  }
  if (window.Notification.permission !== 'granted') {
    // new Notification is supported, so prompt the user for permission.
    window.Notification.requestPermission()
  }
}
